module.exports = __webpack_public_path__ + "static/media/user_redteam.76738174.PNG";